export const CART_WIDGET_TEST_IDS = {
  root: 'cart',
  cartSize: 'cart-size',
  cartPrice: 'cart-price',
  cartPreview: 'cart-preview'
};
